module.exports = __webpack_public_path__ + "static/media/shot-clock.1b15fdb6.jpg";